/** Borde en reposo (alineado con `tokens.color.border.primary` / AWB claro). */
export const FLIGHT_CASES_FILTER_BORDER_IDLE_FALLBACK = '#d9d9d9';
/** Borde al pasar el mouse (#5C5C5C). */
export const FLIGHT_CASES_FILTER_BORDER_HOVER = '#5c5c5c';
/** Borde en focus / menú abierto (único azul para los 3 filtros). */
export const FLIGHT_CASES_FILTER_BORDER_FOCUS = '#0A0E80';

/** Hover de opciones en listas (Estados / Analista): #5c5c5c al 8 %. */
export const FLIGHT_CASES_FILTER_LIST_OPTION_HOVER_BG = '#5c5c5c14';

/**
 * IDs de DOM alineados con `Combobox` / `Select` (listbox = `{root}-listbox` en portal).
 * Usados en estilos globales acotados al hover de opciones.
 */
export const FLIGHT_CASES_STATUS_FILTER_COMBOBOX_ID = 'flight-cases-status-filter-combobox';
export const FLIGHT_CASES_STATUS_FILTER_LISTBOX_ID = `${FLIGHT_CASES_STATUS_FILTER_COMBOBOX_ID}-listbox`;
export const FLIGHT_CASES_ANALYST_FILTER_SELECT_ID = 'flight-cases-analyst-filter';
export const FLIGHT_CASES_ANALYST_FILTER_LISTBOX_ID = `${FLIGHT_CASES_ANALYST_FILTER_SELECT_ID}-listbox`;

export const FALLBACK_FILTER_PRIMARY = FLIGHT_CASES_FILTER_BORDER_FOCUS;
export const FALLBACK_FILTER_BASE_BORDER = FLIGHT_CASES_FILTER_BORDER_HOVER;
export const FALLBACK_FILTER_MUTED = 'rgba(0,0,0,0.6)';

/** Altura unificada de los controles de filtro (AWB, Estados, Analista). */
export const FILTER_CONTROL_HEIGHT_PX = 48;

/** Misma pila que `FilterLabel` / tabla de la página. */
export const FILTER_LATAM_FONT_STACK = `'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif`;
